import { render, staticRenderFns } from "./virtualTree.vue?vue&type=template&id=707d327a&"
import script from "./virtualTree.vue?vue&type=script&lang=js&"
export * from "./virtualTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/virtualTree/virtualTree.vue"
export default component.exports